if (!customElements.get('free-socks-progress')) {
  const FREE_SOCKS_STORAGE_KEY = 'free-socks-last-state';

  customElements.define(
    'free-socks-progress',
    class FreeSocksProgress extends HTMLElement {
      connectedCallback() {
        const state = this.dataset.state;
        const lastState = this.readLastState();

        // Alleen waarschuwen op het moment dat het bedrag van 'gratis' terugzakt; daarna weer de normale melding.
        if (state === 'below_with_socks' && lastState === 'reached_with_socks' && this.dataset.warn !== 'false') {
          this.showLost();
        }
        this.writeLastState(state);
      }

      showLost() {
        const lost = this.querySelector('[data-free-socks-lost]');
        if (!lost) return;

        const message = this.querySelector('[data-free-socks-message]');
        if (message) message.hidden = true;
        lost.hidden = false;
        this.classList.add('free-socks-progress--lost');

        const progressbar = this.querySelector('[role="progressbar"]');
        if (progressbar) progressbar.setAttribute('aria-valuetext', lost.textContent.trim());
      }

      readLastState() {
        try {
          return window.sessionStorage.getItem(FREE_SOCKS_STORAGE_KEY);
        } catch (error) {
          return null;
        }
      }

      writeLastState(state) {
        try {
          window.sessionStorage.setItem(FREE_SOCKS_STORAGE_KEY, state);
        } catch (error) {
          return;
        }
      }
    }
  );

  // Aftelklok tot de einddatum; bij 0 verdwijnt alles wat met data-free-socks-expires is gemarkeerd.
  customElements.define(
    'free-socks-countdown',
    class FreeSocksCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Number(this.dataset.end) * 1000;
        if (!this.end) return;
        this.tick();
        this.timer = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      tick() {
        const remaining = Math.max(0, this.end - Date.now());
        if (remaining === 0) {
          window.clearInterval(this.timer);
          document.querySelectorAll('[data-free-socks-expires]').forEach((element) => {
            const dialog = element.querySelector('dialog[open]');
            if (dialog) dialog.close();
            element.hidden = true;
          });
          const countdown = this.closest('.free-socks-countdown');
          if (countdown) countdown.hidden = true;
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const pad = (value) => String(value).padStart(2, '0');
        const time = `${pad(Math.floor((totalSeconds % 86400) / 3600))}:${pad(Math.floor((totalSeconds % 3600) / 60))}:${pad(totalSeconds % 60)}`;
        this.textContent = days > 0 ? `${days}${this.dataset.day} ${time}` : time;
      }
    }
  );

  // Links met data-free-socks-open openen de sokken-pop-up; zonder pop-up gaan ze gewoon naar de collectie.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-free-socks-open]');
    if (!opener) return;

    const popup = document.querySelector('free-products-popup[data-free-socks-picker]');
    if (!popup || typeof popup.open !== 'function') return;

    event.preventDefault();
    popup.open(true);
  });
}
